import React, { memo } from 'react';

import { Typography, Tooltip, styled } from '@mui/material';
import PropTypes from 'prop-types';

const Div_Container = styled('div')({
  marginInlineEnd: '8px',
});

const Tooltip_FullWidth = styled(Tooltip)({
  maxWidth: 600,
});

const FormCell = memo(({ form = {} }) => {
  if (!form) {
    return null;
  }

  return (
    <Div_Container>
      <Tooltip_FullWidth
        title={form.name}
        placement="top-start"
        leaveDelay={10}
        key="tooltip-name-form"
      >
        <Typography noWrap component="p" variant="subtitleBold">
          {form.name}
        </Typography>
      </Tooltip_FullWidth>
      <Typography noWrap component="p" variant="hint">
        {`#${form?.num}`}
      </Typography>
    </Div_Container>
  );
});

FormCell.propTypes = {
  form: PropTypes.object,
};

export default FormCell;
